import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";  // Zaimportuj hook useAuth

const OAuthCallback = () => {
    const navigate = useNavigate();
    const { login } = useAuth(); // Zdejmujemy login z kontekstu

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const tokenFromUrl = params.get("token");
        const storedToken = sessionStorage.getItem("authToken");

        if (tokenFromUrl) {
            sessionStorage.setItem("authToken", tokenFromUrl);
            login(tokenFromUrl);  // Wywołaj login bezpośrednio po zapisaniu tokenu
            console.log("Token zapisany, przekierowuję do /home");
            navigate("/home", { replace: true });
        } else if (storedToken) {
            login(storedToken);  // Jeżeli token już jest zapisany, wywołaj login
            console.log("Token już zapisany, przekierowuję do /home");
            navigate("/home", { replace: true });
        } else {
            console.log("Brak tokenu, przekierowuję do /login");
            navigate("/login", { replace: true });
        }
    }, [navigate, login]);  // Używamy 'login' w zależności od zmiany

    return <p>Logging in...</p>;
};

export default OAuthCallback;
